<div>
    <div class="row text-center mb-3">
      <div class="col-md-4 mb-3">
        <div class="card rounded-4 shadow-sm users-card">
          <div class="card-body">
            <p class="card-text display-5">{{ platforms_total_count }}</p>
            <h5 class="card-title">Total Platforms</h5>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-3">
        <div class="card rounded-4 shadow-sm users-card">
          <div class="card-body">
            <p class="card-text display-5">{{ platforms_enabled_count }}</p>
            <h5 class="card-title">Enabled Platforms</h5>
          </div>
        </div>
      </div>

      <div class="col-md-4 mb-3">
        <div class="card rounded-4 shadow-sm users-card">
          <div class="card-body">
            <p class="card-text display-5">{{ platforms_disabled_count }}</p>
            <h5 class="card-title">Disabled Platforms</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex mb-3">
      <button
        class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
        @click="$emit('back')"
      >
        Back
      </button>
    </div>

    <div class="card table-card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2 mb-0 text-muted">Loading platforms...</p>
        </div>

        <div v-else class="table-responsive content-table">
          <table id="platform_access_table" class="table text-xs table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Platform</th>
                <th>Status</th>
                <th>Date Created</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody class="text-start text-xs">
              <tr v-for="(p, index) in platform_access_rows" :key="p.platform_id">
                <td>{{ index + 1 }}</td>

                <td>
                  <strong>{{ p.platform_name }}</strong>
                </td>

                <td>
                  <span v-if="p.status === 'ENABLED'" class="badge bg-success">Enabled</span>
                  <span v-else-if="p.status === 'DISABLED'" class="badge bg-danger">Disabled</span>
                  <span v-else class="badge bg-secondary">{{ p.status || 'DISABLED' }}</span>
                </td>

                <td>
                  <span class="text-muted">{{ p.date_created || '-' }}</span>
                </td>

                <td class="text-nowrap">
                  <button
                    v-if="p.status !== 'ENABLED'"
                    class="btn btn-sm upload-button text-white"
                    :disabled="saving_id === p.platform_id"
                    @click="confirm_set_platform_access(p.platform_id, 'ENABLE')"
                  >
                    <span v-if="saving_id === p.platform_id" class="spinner-border spinner-border-sm me-2"></span>
                    <i v-else class="fas fa-check me-1"></i>
                    Enable
                  </button>

                  <button
                    v-else
                    class="btn btn-sm btn-danger text-nowrap"
                    :disabled="saving_id === p.platform_id"
                    @click="confirm_set_platform_access(p.platform_id, 'REVOKE')"
                  >
                    <span v-if="saving_id === p.platform_id" class="spinner-border spinner-border-sm me-2"></span>
                    <i v-else class="fas fa-ban me-1"></i>
                    Revoke
                  </button>
                </td>
              </tr>

              <tr v-if="platform_access_rows.length === 0">
                <td colspan="5" class="text-center text-muted py-4">
                  No platforms found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>